import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "image",
    "button",
    "file",
    "base64",
    "remove",
    "removeButton",
  ]

  connect() {
    // set initial state - show existing image if available
    if (this.fileTarget.dataset.existing) {
      this.element.classList.add("existing-image")
    }

    this.notifyStateChange()
  }

  select() {
    this.fileTarget.click()
  }

  remove() {
    // reset the interface to default
    this.element.classList.remove("existing-image", "selected-image")

    // reset file field and set file purge request
    this.fileTarget.value = ""
    this.removeTarget.value = "true"
    this.base64Target.value = ""

    // hide the image
    this.imageTarget.style.display = "none"

    this.notifyStateChange()
  }

  changed() {
    const file = this.fileTarget.files?.[0]
    if (!file) return

    // load selected image and display it
    const reader = new FileReader()
    reader.onload = (e) => {
      this.imageTarget.src = e.target.result
      this.imageTarget.style.display = "block"
      this.base64Target.value = e.target.result

      // show the image has been selected
      this.element.classList.add("existing-image", "selected-image")

      // ensure new image is not immediately removed
      this.removeTarget.value = ""

      this.notifyStateChange()
    }

    reader.readAsDataURL(file)
  }

  notifyStateChange() {
    this.element.dispatchEvent(
      new CustomEvent("image-upload:changed", { bubbles: true }),
    )
  }
}
